
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { Baseservice } from './baseservice';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FreightTypeService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('freight-type', http, authentication);
  }
  getAllFreightTypes(){
      
    return this.http.get(this.url);
}
getFreightTypeById(id){
  return this.http.get(this.url+"/"+id);

}
postFreightType(object:any){
  let body = object;
  return this.http.post(this.url, body);

}
updateFreightType(object:any){
  let body = object;
  return this.http.put(this.url, body);

}

}
